import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%"   viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">


<path d="M6945 8594 c-80 -6 -232 -34 -335 -61 -376 -98 -741 -323 -983 -606
-28 -34 -60 -70 -71 -82 -34 -37 -148 -216 -198 -310 -56 -106 -128 -279 -128
-307 0 -17 13 -18 198 -18 108 0 287 -3 397 -7 l200 -6 13 28 c52 114 206 290
342 391 85 63 264 159 351 188 123 40 248 66 355 72 129 8 340 -10 391 -32 17
-8 39 -14 50 -15 26 0 146 -48 231 -92 106 -55 202 -156 280 -296 14 -25 33
-59 42 -76 30 -54 88 -228 105 -320 10 -50 21 -159 24 -243 l6 -154 65 44
c106 71 177 125 284 218 163 141 376 375 376 413 0 18 -43 141 -72 207 -81
181 -187 351 -284 455 -31 33 -68 74 -83 90 -29 32 -70 59 -78 52 -2 -3 9 -15
24 -27 l28 -23 -25 6 c-24 6 -25 5 -22 -38 3 -36 1 -45 -12 -45 -9 0 -16 7
-16 15 0 11 -11 15 -42 13 -37 -1 -39 -2 -10 -5 59 -8 33 -23 -38 -23 -68 0
-70 -1 -70 -25 0 -22 -4 -25 -40 -25 -29 0 -40 -4 -40 -15 0 -12 -17 -15 -92
-14 -51 0 -87 3 -80 6 33 13 4 23 -68 23 -47 0 -80 4 -80 10 0 6 -18 10 -40
10 l-40 0 0 50 c0 46 -2 50 -24 50 -13 0 -38 3 -55 6 -25 5 -31 11 -31 33 0
35 -17 51 -52 51 -26 0 -28 3 -28 40 0 36 -2 40 -25 40 -22 0 -25 4 -25 40 0
29 -4 40 -15 40 -11 0 -15 11 -15 40 0 22 -5 40 -11 40 -7 0 -9 29 -7 84 l3
85 -61 10 c-64 12 -385 22 -469 15z m458 -31 c-7 -2 -21 -2 -30 0 -10 3 -4 5
12 5 17 0 24 -2 18 -5z m1117 -536 l25 -32 -32 23 c-18 13 -33 28 -33 33 0 17
15 8 40 -24z m85 -97 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0
8 -4 11 -10z"/>
<path d="M3855 8574 c-677 -91 -1315 -543 -1582 -1122 -31 -67 -91 -237 -107
-304 l-6 -28 95 0 c111 0 108 5 103 -130 l-3 -85 -90 -2 c-49 -2 -101 -5 -114
-8 l-23 -6 5 -207 c3 -131 10 -235 20 -283 52 -249 134 -450 267 -649 69 -105
131 -156 299 -249 262 -145 664 -241 1015 -241 79 0 97 -3 88 -12 -18 -18
-464 -24 -614 -9 -371 37 -718 143 -935 287 -156 103 -256 227 -289 355 -25
95 -14 239 26 344 37 100 37 108 0 65 -171 -200 -255 -417 -232 -600 10 -81
54 -211 73 -218 5 -2 9 -8 9 -14 0 -6 14 -28 32 -51 143 -180 389 -317 703
-391 447 -104 1069 -100 1550 10 168 38 173 40 277 78 125 45 217 86 315 138
84 45 287 171 308 191 7 7 27 23 45 37 74 58 238 210 226 210 -2 0 23 27 55
60 33 32 59 63 59 68 0 9 11 23 66 84 13 15 24 30 24 33 0 3 14 24 30 47 17
22 30 48 30 56 0 12 -3 12 -14 -4 -14 -18 -15 -18 -21 -2 -4 10 -11 15 -17 12
-5 -3 -8 5 -7 18 1 12 1 40 1 62 -2 29 -5 37 -17 32 -12 -4 -15 4 -15 44 0 28
-4 50 -10 50 -5 0 -10 18 -10 40 0 29 -4 40 -15 40 -12 0 -15 15 -15 79 0 79
0 80 -27 83 l-28 3 -3 153 c-2 129 0 153 13 158 10 4 15 19 15 45 0 28 4 39
15 39 11 0 15 11 15 40 0 29 4 40 15 40 11 0 15 11 15 38 0 27 3 33 10 22 8
-12 10 -11 10 6 0 19 -6 21 -77 23 -112 3 -104 11 10 11 54 0 97 4 97 9 0 15
-1856 44 -1918 30 -49 -11 -92 -36 -92 -53 0 -7 21 -33 48 -57 26 -25 81 -82
122 -128 41 -46 82 -91 91 -100 9 -9 38 -41 64 -71 161 -184 257 -279 308
-301 l52 -24 371 3 c205 2 374 -1 377 -5 20 -33 -194 -263 -327 -353 -92 -61
-234 -130 -321 -155 -33 -9 -73 -20 -90 -25 -130 -37 -448 -38 -580 -2 -289
78 -485 235 -609 487 -69 141 -90 239 -90 425 -1 138 2 165 27 253 73 263 229
477 458 630 138 91 265 145 449 189 75 18 136 21 540 28 250 5 511 9 580 9
l125 1 105 127 c58 70 163 195 234 278 70 82 138 161 150 175 11 14 45 53 74
87 28 33 52 63 52 67 0 3 -397 6 -882 5 -679 -1 -906 -4 -983 -15z m1695
-2579 c0 -12 -19 -12 -23 0 -4 9 -1 12 9 8 7 -3 14 -7 14 -8z m-210 -259 c0
-2 -7 -7 -16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m-3530 -73 c0 -19 -13
-9 -16 12 -1 8 2 13 7 9 5 -3 9 -12 9 -21z m60 -163 c0 -5 -5 -10 -11 -10 -5
0 -7 5 -4 10 3 6 8 10 11 10 2 0 4 -4 4 -10z"/>
<path d="M7568 8533 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M1570 8445 c0 -25 -4 -45 -10 -45 -5 0 -9 -19 -9 -42 l2 -43 6 39 c9
60 31 59 31 -2 0 -71 10 -110 29 -115 14 -4 14 -5 -1 -6 -10 0 -18 -5 -18 -11
0 -6 43 -10 110 -10 l110 0 0 140 0 140 -125 0 -125 0 0 -45z"/>
<path d="M2294 8397 c-2 -7 -3 -65 -2 -128 l3 -114 125 0 125 0 0 125 0 125
-123 3 c-95 2 -124 0 -128 -11z"/>
<path d="M8430 8318 c36 -5 131 -17 211 -28 80 -11 184 -31 230 -44 46 -14 86
-20 87 -15 2 5 8 9 13 9 4 0 6 -7 3 -15 -6 -14 -2 -16 47 -20 9 0 24 -8 33
-18 10 -9 24 -17 32 -17 8 0 14 -4 14 -9 0 -5 8 -11 18 -15 26 -9 97 -51 100
-59 1 -4 10 -15 20 -25 9 -10 28 -31 41 -47 117 -140 121 -319 10 -562 -20
-44 -143 -241 -158 -253 -3 -3 -22 -25 -40 -50 -57 -74 -136 -155 -266 -275
-16 -15 -46 -39 -65 -54 -19 -14 -44 -34 -55 -44 -33 -31 -196 -151 -247 -183
-46 -28 -60 -44 -38 -44 6 0 10 -9 10 -19 0 -11 -4 -23 -10 -26 -17 -10 -11
-25 10 -25 24 0 26 -16 5 -37 -8 -8 -12 -19 -9 -25 4 -6 2 -8 -4 -4 -5 3 -13
0 -15 -6 -3 -7 -6 6 -6 29 -1 23 -7 44 -13 46 -10 4 -10 6 0 6 6 1 12 14 12
30 0 24 -3 28 -19 24 -11 -3 -27 -13 -37 -24 -16 -18 -16 -19 7 -28 23 -10 22
-10 -7 -9 -23 2 -30 6 -26 16 4 12 2 12 -17 1 -23 -15 -28 -39 -8 -40 6 0 4
-4 -6 -7 -17 -7 -16 -9 3 -30 11 -12 28 -22 38 -22 14 0 15 -2 2 -10 -8 -5
-11 -12 -8 -16 11 -10 40 4 33 16 -3 5 1 10 9 10 9 0 16 -7 16 -15 0 -8 4 -15
9 -15 5 0 16 7 25 15 8 8 23 15 33 14 14 0 15 -2 3 -6 -19 -7 -50 -34 -50 -44
0 -4 22 5 50 19 27 14 46 30 43 35 -4 6 0 8 9 4 9 -3 36 7 62 24 26 16 61 36
79 44 18 8 39 19 47 24 8 6 71 45 140 87 69 42 127 80 130 83 8 10 69 51 75
51 3 0 20 13 38 30 18 16 35 30 39 30 16 0 271 211 367 304 200 194 340 403
370 554 51 248 -89 442 -404 562 -33 12 -69 26 -80 31 -49 20 -225 48 -276 44
-37 -3 -46 -2 -29 4 35 12 12 19 -75 25 -38 3 -110 9 -160 15 -119 13 -490 12
-395 -1z m477 -34 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m102
-3 c9 -6 0 -10 -29 -13 -42 -4 -65 7 -33 15 30 8 47 7 62 -2z m147 -28 c-7 -7
-108 -5 -115 3 -2 2 24 4 59 4 35 0 60 -3 56 -7z m61 -9 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m-130 -20 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6
6 11 1 17 -2 13 -5z m24 -24 c5 0 9 -4 9 -10 0 -16 -26 -12 -41 7 -12 15 -12
16 4 10 10 -4 23 -7 28 -7z m-721 -1690 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10
10 0 6 5 10 10 10 6 0 10 -4 10 -10z m147 -76 c-3 -3 -12 -4 -19 -1 -8 3 -5 6
6 6 11 1 17 -2 13 -5z"/>
<path d="M1558 8213 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M2024 8127 c-2 -7 -3 -67 -2 -133 l3 -119 125 0 125 0 0 130 0 130
-123 3 c-95 2 -124 0 -128 -11z"/>
<path d="M1145 8074 c-16 -2 -54 -7 -83 -10 -29 -3 -50 -10 -46 -15 3 -5 9 -7
13 -5 4 3 13 1 21 -5 12 -7 10 -9 -9 -9 -19 0 -22 -4 -18 -22 3 -13 9 -56 13
-95 5 -52 11 -73 20 -73 19 0 20 -109 2 -112 -25 -3 128 -16 204 -17 73 -1 78
0 83 22 3 12 4 94 3 182 l-3 160 -85 1 c-47 1 -98 0 -115 -2z"/>
<path d="M1667 7863 c-4 -3 -7 -82 -7 -174 0 -143 2 -168 16 -173 9 -3 85 -6
169 -6 142 0 155 2 165 19 11 21 14 280 4 319 -6 22 -9 22 -173 22 -92 0 -171
-3 -174 -7z"/>
<path d="M7757 7594 c-3 -3 -45 -16 -94 -29 -188 -49 -348 -96 -356 -104 -4
-4 24 -27 63 -51 39 -23 72 -46 75 -50 2 -4 -11 -38 -30 -76 l-35 -69 -7 -482
c-3 -275 -2 -483 2 -483 13 0 181 69 230 95 l40 20 5 370 c4 330 7 373 23 401
32 59 39 59 112 13 36 -23 68 -40 70 -38 4 4 -19 228 -34 329 -6 36 -13 86
-16 113 -5 36 -10 47 -24 47 -10 0 -20 -3 -24 -6z"/>
<path d="M1352 7353 l3 -128 128 -3 127 -3 0 131 0 130 -130 0 -131 0 3 -127z"/>
<path d="M901 7098 c1 -50 3 -57 9 -33 6 23 8 25 9 8 0 -12 6 -25 12 -29 7 -4
9 -24 6 -56 -5 -41 -4 -49 8 -44 17 6 20 -5 5 -20 -8 -8 17 -13 82 -17 54 -4
97 -2 103 4 11 11 20 188 11 224 l-6 25 -120 0 -120 0 1 -62z"/>
<path d="M6868 7129 c-17 -9 -18 -46 -18 -544 0 -294 4 -535 8 -535 10 0 192
65 325 116 l47 18 0 472 0 472 -22 6 c-38 10 -322 6 -340 -5z"/>
<path d="M1717 7103 l-48 -4 2 -172 c1 -95 4 -166 6 -159 3 6 11 12 19 12 9 0
12 -4 9 -10 -10 -16 35 -21 170 -18 l130 3 0 175 0 175 -120 1 c-66 0 -142 -1
-168 -3z m-20 -205 c-2 -13 -4 -5 -4 17 -1 22 1 32 4 23 2 -10 2 -28 0 -40z
m10 -104 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M907 6919 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M6336 6784 c-3 -8 -6 -177 -6 -373 l0 -358 68 -57 c77 -66 85 -67
230 -21 l82 26 -2 397 -3 397 -181 3 c-159 2 -182 0 -188 -14z"/>
<path d="M1393 6593 c-33 -4 -33 -5 -33 -59 0 -48 2 -54 21 -54 16 0 19 -3 11
-12 -12 -15 -11 -68 2 -68 4 0 6 -7 2 -15 -3 -8 -1 -15 4 -15 6 0 10 -7 10
-15 0 -13 15 -15 98 -13 l97 3 0 125 0 125 -90 1 c-49 1 -105 -1 -122 -3z"/>
<path d="M8950 6524 c-95 -72 -287 -204 -296 -204 -3 0 -32 -18 -65 -40 -33
-22 -62 -40 -65 -40 -2 0 -34 -19 -71 -42 -72 -43 -435 -228 -450 -228 -5 0
-27 -18 -48 -41 -213 -218 -581 -356 -890 -334 -526 38 -947 364 -1081 838
-15 53 -31 94 -34 90 -4 -5 -17 -44 -29 -88 -45 -160 -169 -426 -273 -584 -26
-41 -48 -76 -48 -78 0 -3 -25 -37 -55 -76 -30 -39 -55 -74 -55 -79 0 -32 197
-242 320 -341 210 -170 485 -309 735 -374 203 -52 250 -57 525 -57 274 0 290
2 500 54 110 26 295 97 412 155 466 234 815 631 972 1105 39 120 89 353 84
397 l-3 30 -85 -63z"/>
<path d="M8353 6343 c-3 -10 -9 -22 -12 -28 -3 -5 6 -3 19 6 13 9 26 21 28 27
6 19 -28 14 -35 -5z"/>
<path d="M8285 6300 c-16 -7 -17 -9 -3 -9 9 -1 20 4 23 9 7 11 7 11 -20 0z"/>
<path d="M7645 6170 c-15 -6 -8 -8 25 -8 33 1 39 3 25 9 -25 9 -25 9 -50 -1z"/>
<path d="M5602 6140 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M5620 6126 c0 -9 5 -16 10 -16 6 0 10 4 10 9 0 6 -4 13 -10 16 -5 3
-10 -1 -10 -9z"/>
<path d="M7475 6098 c-55 -22 -114 -47 -132 -54 -18 -8 -63 -25 -100 -38 -318
-110 -486 -166 -497 -166 -7 0 -20 -6 -30 -13 -15 -11 -6 -17 77 -44 l95 -31
68 19 c38 11 96 28 129 38 33 11 101 31 150 46 113 34 409 146 413 157 2 4 16
8 30 8 19 0 23 3 13 9 -7 5 -10 14 -7 20 5 8 0 8 -19 1 -33 -13 -45 -13 -45 0
0 6 11 10 24 10 14 0 28 5 31 10 8 13 -31 13 -56 0 -18 -10 -25 -3 -20 24 1 5
-5 6 -13 3 -8 -3 -30 -8 -48 -10 -18 -2 -25 -2 -15 0 9 2 17 9 17 14 0 5 6 9
13 9 7 0 22 7 33 15 33 25 -4 16 -111 -27z m139 -83 c-4 -8 -8 -15 -10 -15 -2
0 -4 7 -4 15 0 8 4 15 10 15 5 0 7 -7 4 -15z"/>
<path d="M7755 6060 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M6469 4569 c-82 -9 -133 -34 -186 -92 -49 -53 -63 -93 -72 -202 l-6
-80 -55 -5 -55 -5 -3 -102 -3 -102 58 -3 58 -3 3 -332 2 -333 140 0 140 0 2
333 3 332 93 3 92 3 0 104 0 104 -92 3 c-105 3 -109 7 -88 83 19 67 88 94 152
61 15 -8 29 -12 32 -8 4 8 56 188 56 196 0 10 -107 43 -155 48 -27 2 -80 1
-116 -3z"/>
<path d="M2788 4523 c-2 -5 -1 -278 2 -608 l5 -600 140 0 140 0 2 255 c3 282
8 315 60 360 33 29 99 54 124 46 8 -2 26 -7 41 -10 30 -7 70 -40 84 -71 5 -11
11 -146 14 -300 l5 -280 138 -3 138 -3 -3 333 -3 333 -27 55 c-44 92 -100 140
-200 171 -105 33 -228 17 -318 -41 l-45 -29 -6 182 c-3 100 -6 183 -7 184 -1
1 -9 9 -18 17 -12 13 -40 16 -139 16 -68 0 -125 -3 -127 -7z"/>
<path d="M7350 4506 c0 -7 7 -33 15 -56 16 -46 22 -294 7 -318 -6 -9 -19 -5
-53 18 -61 40 -158 64 -234 58 -56 -5 -166 -43 -173 -60 -2 -4 -9 -8 -16 -8
-6 0 -33 -21 -58 -47 -179 -183 -182 -500 -6 -675 114 -114 256 -153 396 -109
33 10 76 31 96 46 39 29 42 29 60 -7 11 -22 18 -23 139 -26 l127 -3 0 578 c0
507 -2 581 -16 601 -14 21 -22 22 -150 22 -107 0 -134 -3 -134 -14z m-67 -563
c47 -33 71 -69 89 -136 26 -98 -32 -226 -119 -263 -50 -21 -132 -18 -173 7
-74 46 -104 100 -104 194 -1 56 4 80 24 119 55 110 187 147 283 79z"/>
<path d="M1213 4452 c-7 -5 -59 -111 -116 -238 -57 -126 -116 -256 -132 -289
-15 -33 -51 -114 -80 -180 -29 -66 -85 -187 -123 -270 -39 -82 -67 -153 -63
-158 4 -4 74 -6 155 -5 l147 3 56 128 56 127 242 0 c182 0 245 -3 252 -12 5
-7 29 -60 53 -118 24 -58 48 -111 53 -117 7 -9 50 -13 152 -13 78 0 144 3 148
6 3 4 0 22 -9 42 -8 19 -12 37 -10 40 3 2 25 -7 49 -21 123 -73 311 -104 440
-73 170 40 257 136 257 283 0 137 -84 214 -295 268 -147 38 -164 45 -180 69
-13 19 -13 28 -4 50 29 63 163 57 300 -13 l79 -40 21 72 c12 40 24 88 26 107
5 34 3 36 -47 57 -103 45 -161 57 -275 58 -181 0 -292 -50 -348 -156 -26 -49
-29 -61 -25 -136 4 -71 8 -86 33 -120 16 -21 36 -44 45 -50 35 -29 123 -64
235 -93 148 -39 167 -50 163 -93 -9 -92 -187 -83 -358 17 -48 28 -62 33 -66
21 -3 -7 -16 -51 -28 -96 -24 -86 -39 -106 -52 -67 -6 20 -89 209 -228 518
-19 41 -74 164 -122 274 -48 109 -94 205 -102 212 -10 11 -47 14 -150 14 -75
0 -143 -4 -149 -8z m164 -339 c3 -10 33 -78 65 -151 32 -73 58 -139 58 -147 0
-13 -23 -15 -134 -15 -74 0 -137 4 -140 8 -3 5 14 51 37 103 23 52 53 122 67
157 26 64 36 74 47 45z"/>
<path d="M8699 4360 c-1 -19 -3 -63 -4 -97 -1 -35 -5 -66 -9 -70 -7 -8 -16 -9
-78 -12 l-28 -1 0 -100 0 -100 49 0 c28 0 52 -4 56 -10 3 -5 7 -105 10 -222 3
-201 16 -308 36 -308 5 0 9 -6 9 -13 0 -19 66 -83 105 -101 51 -25 143 -39
206 -32 56 5 164 40 173 55 4 6 -41 190 -48 198 -1 1 -23 -5 -49 -14 -59 -19
-109 -11 -137 24 -19 24 -20 39 -20 224 l0 199 110 0 111 0 -3 103 -3 102
-105 0 -105 0 -3 98 c-2 67 -7 99 -15 103 -7 2 -68 6 -135 7 l-122 2 -1 -35z"/>
<path d="M4065 4214 c-11 -2 -45 -9 -75 -15 -67 -14 -200 -73 -200 -90 0 -28
66 -189 78 -189 7 0 41 15 75 33 150 81 293 71 342 -23 8 -16 15 -41 15 -55
l0 -25 -84 6 c-218 17 -407 -59 -462 -185 -17 -40 -19 -145 -3 -192 39 -116
162 -189 317 -189 77 0 128 15 191 55 l42 26 10 -31 11 -31 132 3 131 3 3 295
c2 270 1 301 -17 360 -38 124 -117 194 -259 231 -69 17 -191 24 -247 13z m235
-569 c0 -48 -22 -88 -67 -122 -32 -24 -45 -28 -104 -28 -51 0 -72 4 -87 18
-49 45 -34 114 31 146 33 17 61 21 135 21 l92 0 0 -35z"/>
<path d="M5145 4210 c-53 -11 -103 -34 -142 -66 -31 -25 -33 -25 -33 -7 0 11
-9 28 -21 39 -18 16 -37 19 -147 19 l-127 0 3 -50 c2 -27 5 -227 8 -443 l5
-393 137 3 137 3 5 230 c4 155 10 240 18 260 33 77 128 135 219 135 l34 0 -3
138 -3 137 -25 2 c-14 0 -43 -3 -65 -7z"/>
<path d="M5511 4204 c-73 -15 -221 -75 -221 -90 0 -14 62 -179 71 -189 6 -6
30 2 67 22 70 38 152 63 206 63 85 -1 166 -64 166 -130 l0 -25 -133 0 c-200
-1 -315 -43 -388 -144 -27 -36 -33 -54 -37 -116 -8 -131 39 -215 155 -272 53
-25 68 -28 164 -28 100 0 109 2 169 33 75 38 78 38 82 10 3 -22 7 -23 136 -26
l133 -3 -3 338 -3 338 -35 56 c-74 119 -173 169 -350 175 -68 2 -131 -2 -179
-12z m289 -556 c0 -31 -26 -85 -54 -113 -26 -27 -78 -45 -126 -45 -44 0 -56 4
-82 30 -26 27 -30 36 -24 68 10 66 62 90 199 91 l87 1 0 -32z"/>
<path d="M7970 4194 c-84 -18 -190 -70 -190 -92 1 -28 56 -176 68 -180 6 -2
28 8 49 22 55 36 148 66 207 66 98 -1 176 -60 176 -135 l0 -30 -148 0 c-139
-1 -151 -3 -220 -30 -93 -38 -138 -75 -168 -139 -59 -126 -7 -279 115 -340
116 -58 230 -59 347 -1 40 19 74 35 77 35 3 0 7 -10 9 -22 3 -22 7 -23 136
-26 l132 -3 0 268 c0 147 -5 296 -10 330 -11 65 -45 141 -83 181 -33 36 -115
79 -183 96 -76 20 -225 20 -314 0z m311 -526 c9 -99 -75 -188 -178 -188 -96 0
-146 60 -112 134 21 45 81 66 192 66 70 0 97 -3 98 -12z"/>
<path d="M9543 4200 c-84 -18 -204 -67 -217 -89 -6 -8 44 -150 62 -178 6 -10
25 -4 73 22 154 82 305 72 353 -23 18 -36 28 -82 19 -82 -5 0 -73 -2 -153 -3
-130 -3 -152 -6 -216 -31 -90 -34 -140 -76 -170 -140 -50 -106 -21 -234 69
-311 47 -41 146 -75 216 -75 64 0 158 26 203 55 47 31 58 31 58 0 l0 -25 135
0 135 0 0 268 c0 147 -5 296 -11 332 -20 125 -97 219 -215 262 -66 24 -264 34
-341 18z m287 -563 c0 -29 -8 -54 -25 -79 -69 -102 -252 -104 -271 -3 -16 85
47 124 199 125 l97 0 0 -43z"/>
<path d="M2355 2945 c-41 -22 -55 -43 -55 -85 0 -43 17 -61 80 -86 25 -9 51
-22 58 -27 15 -12 16 -49 0 -65 -15 -15 -73 -15 -97 0 -15 9 -23 9 -35 -1 -22
-19 -5 -38 46 -51 102 -28 191 73 126 143 -13 13 -45 32 -71 42 -53 19 -62 32
-53 71 7 25 9 26 68 22 70 -4 87 12 39 36 -38 20 -68 20 -106 1z"/>
<path d="M2834 2949 c-43 -12 -89 -61 -103 -110 -28 -93 25 -187 119 -209 41
-10 58 -9 104 4 l55 16 6 53 c4 30 5 64 3 78 -3 22 -7 24 -58 24 -43 0 -55 -3
-58 -17 -2 -12 5 -17 30 -20 30 -3 33 -7 36 -38 5 -44 -17 -60 -80 -60 -39 0
-54 5 -78 29 -55 52 -49 152 12 195 27 19 96 21 133 4 22 -10 28 -9 36 3 14
22 11 26 -31 43 -44 18 -79 19 -126 5z"/>
<path d="M3728 2952 c-28 -3 -68 -44 -68 -69 0 -8 7 -27 15 -43 14 -27 14 -30
-15 -59 -53 -53 -35 -130 35 -150 37 -10 76 -3 113 20 18 11 24 11 40 -4 21
-20 52 -23 52 -5 0 6 -10 22 -22 35 l-22 23 22 45 c27 56 27 57 0 53 -13 -2
-27 -13 -33 -25 -13 -30 -35 -29 -58 3 -18 25 -18 25 7 51 58 58 17 136 -66
125z m40 -41 c18 -11 12 -51 -9 -64 -26 -16 -49 -1 -49 32 0 27 6 33 40 40 3
0 11 -3 18 -8z m-10 -166 c18 -19 32 -39 32 -44 0 -16 -35 -31 -70 -31 -48 0
-60 49 -22 93 20 23 24 22 60 -18z"/>
<path d="M5765 2946 c-105 -47 -133 -193 -52 -273 81 -81 227 -52 267 53 14
37 12 111 -4 142 -40 76 -136 111 -211 78z m130 -52 c37 -24 58 -87 45 -135
-16 -59 -54 -89 -113 -89 -42 0 -53 5 -78 31 -51 55 -51 129 1 180 23 24 37
29 75 29 25 0 56 -7 70 -16z"/>
<path d="M7963 2946 c-82 -37 -65 -151 26 -172 62 -15 91 -60 59 -92 -16 -16
-73 -15 -98 0 -15 10 -22 10 -31 1 -19 -19 -3 -39 43 -52 81 -22 148 18 148
89 0 44 -15 59 -92 94 -49 21 -58 29 -58 50 0 16 9 32 24 41 22 14 28 14 59 1
32 -13 37 -13 48 0 30 36 -68 67 -128 40z"/>
<path d="M9385 2953 c-37 -10 -77 -46 -96 -87 -60 -133 43 -266 183 -234 54
12 83 35 67 55 -15 17 -34 17 -49 -2 -8 -9 -29 -15 -56 -15 -64 0 -105 39
-111 106 -6 63 24 113 81 132 35 11 43 10 77 -7 32 -17 39 -18 49 -6 31 38
-67 77 -145 58z"/>
<path d="M9980 2949 c-45 -18 -60 -40 -60 -84 0 -50 13 -63 93 -99 47 -20 57
-29 57 -49 0 -47 -31 -55 -121 -32 -38 10 -47 -20 -13 -42 35 -22 110 -20 143
5 33 24 46 68 32 105 -8 21 -27 35 -74 56 -64 29 -81 48 -71 76 8 19 38 27 93
23 56 -4 66 17 17 37 -40 17 -61 18 -96 4z"/>
<path d="M784 2930 c-106 -53 -112 -208 -11 -279 27 -20 161 -22 195 -3 20 11
22 20 22 87 l0 75 -54 0 c-35 0 -56 -5 -59 -12 -8 -24 5 -38 34 -38 25 0 29
-4 29 -30 0 -38 -29 -54 -87 -47 -68 7 -102 58 -90 135 4 23 17 46 33 60 24
21 35 24 98 20 59 -2 71 0 74 13 7 39 -117 52 -184 19z"/>
<path d="M1185 2943 c-85 -22 -129 -132 -90 -226 30 -72 150 -111 225 -72 86
45 113 176 50 253 -35 42 -116 62 -185 45z m108 -54 c65 -29 75 -130 17 -181
-43 -39 -94 -38 -137 3 -29 26 -33 36 -33 80 0 44 4 55 31 80 34 31 78 38 122
18z"/>
<path d="M1645 2938 c-3 -8 -4 -79 -3 -158 l3 -145 86 0 c79 0 89 3 123 28 47
36 66 75 66 132 0 56 -19 96 -62 126 -26 19 -48 24 -120 27 -69 4 -89 1 -93
-10z m147 -38 c52 -15 78 -51 78 -111 0 -66 -36 -104 -108 -114 -28 -4 -56 -4
-62 0 -11 7 -15 217 -3 228 9 10 53 8 95 -3z"/>
<path d="M2010 2790 l0 -160 105 0 c98 0 105 1 105 20 0 18 -7 20 -80 20 -76
0 -80 1 -86 24 -3 13 -4 35 -2 47 3 22 9 24 73 29 62 4 70 7 70 25 0 18 -7 20
-63 21 -34 0 -67 5 -73 11 -6 6 -9 26 -7 44 l3 34 78 3 c69 3 77 5 77 22 0 19
-7 20 -100 20 l-100 0 0 -160z"/>
<path d="M2595 2938 c-3 -8 -4 -79 -3 -158 3 -137 4 -145 23 -145 19 0 20 7
20 155 0 140 -2 155 -18 158 -9 2 -19 -3 -22 -10z"/>
<path d="M3120 2790 c0 -153 1 -160 20 -160 19 0 20 7 20 120 0 66 4 120 8
120 5 0 42 -51 82 -112 82 -124 85 -128 118 -128 22 0 22 1 22 160 0 153 -1
160 -20 160 -19 0 -20 -7 -20 -115 0 -85 -3 -115 -12 -115 -7 0 -46 52 -86
115 -66 104 -77 115 -103 115 l-29 0 0 -160z"/>
<path d="M4140 2790 l0 -160 73 0 c137 1 197 51 197 167 0 55 -4 66 -30 96
-35 41 -85 57 -174 57 l-66 0 0 -160z m159 104 c99 -39 87 -183 -17 -215 -21
-6 -51 -9 -67 -7 l-30 3 -3 104 c-1 58 0 111 2 118 7 18 67 16 115 -3z"/>
<path d="M4507 2943 c-4 -3 -7 -75 -7 -160 l0 -153 105 0 c63 0 105 4 105 10
0 6 0 13 0 18 0 4 -35 9 -77 12 l-78 5 -3 47 -3 47 68 3 c60 3 68 5 68 23 0
15 -6 19 -25 17 -14 -2 -44 0 -68 3 l-43 6 3 42 3 42 73 3 c64 3 72 5 72 22 0
18 -7 20 -93 20 -52 0 -97 -3 -100 -7z"/>
<path d="M4774 2933 c4 -10 30 -81 60 -158 47 -122 56 -140 76 -140 19 0 30
19 81 149 32 82 59 153 59 158 0 5 -10 8 -22 6 -18 -2 -30 -23 -64 -113 -23
-60 -46 -111 -51 -112 -6 -2 -20 25 -33 59 -62 172 -60 168 -86 168 -20 0 -24
-4 -20 -17z"/>
<path d="M5129 2908 c-1 -52 -1 -224 0 -256 1 -22 3 -23 103 -20 88 3 103 6
106 20 3 15 -8 18 -80 20 l-83 3 -3 48 -3 47 71 0 c56 0 72 3 77 16 9 24 -13
32 -81 32 l-61 -1 0 44 0 44 78 3 c68 2 78 5 75 20 -3 14 -18 17 -101 20 l-97
3 -1 -43z"/>
<path d="M5430 2790 l0 -160 90 0 c83 0 90 2 90 20 0 17 -8 19 -67 22 l-68 3
-3 138 c-2 129 -4 137 -22 137 -19 0 -20 -7 -20 -160z"/>
<path d="M6080 2789 l0 -160 23 3 c20 3 22 9 23 68 l1 65 56 3 c71 4 107 33
107 87 0 72 -35 95 -146 95 l-64 0 0 -161z m141 111 c12 -7 19 -21 19 -40 0
-35 -23 -50 -75 -50 -41 0 -50 14 -41 65 6 32 10 35 42 35 19 0 44 -5 55 -10z"/>
<path d="M6378 2818 c-4 -165 -1 -188 23 -188 17 0 19 11 21 123 3 112 4 120
17 92 28 -62 32 -72 56 -140 18 -53 29 -71 44 -73 12 -2 21 2 21 10 1 7 20 62
44 122 50 126 56 123 56 -30 0 -96 1 -104 19 -104 18 0 20 9 23 88 2 48 2 120
0 160 -3 72 -3 72 -31 72 -36 0 -40 -6 -85 -120 -21 -52 -41 -99 -45 -103 -5
-4 -18 20 -31 55 -12 35 -33 87 -46 116 -21 45 -27 52 -53 52 l-29 0 -4 -132z"/>
<path d="M6810 2790 l0 -161 102 3 c88 3 103 6 106 20 3 15 -8 18 -80 20 l-83
3 0 45 0 45 70 5 c56 4 70 8 73 23 2 9 0 17 -5 18 -4 0 -36 1 -71 1 -56 1 -63
4 -68 24 -3 12 -4 33 -2 45 3 23 8 24 81 27 68 2 78 5 75 20 -3 14 -18 17
-101 20 l-97 3 0 -161z"/>
<path d="M7110 2790 c0 -153 1 -160 20 -160 19 0 20 7 20 120 0 66 4 120 8
120 4 0 16 -15 27 -32 10 -18 24 -39 31 -45 7 -7 22 -29 34 -50 58 -97 72
-113 101 -113 l29 0 0 160 c0 153 -1 160 -20 160 -11 0 -20 -3 -21 -7 0 -5 -1
-54 -2 -111 -1 -58 -6 -103 -12 -104 -5 -1 -38 40 -73 92 -81 123 -87 130
-117 130 l-25 0 0 -160z"/>
<path d="M7455 2939 c-11 -17 6 -27 54 -31 l44 -3 1 -135 c1 -131 2 -135 23
-138 22 -3 22 -1 25 135 l3 138 48 3 c39 3 48 6 45 20 -3 15 -20 17 -120 20
-78 2 -119 -1 -123 -9z"/>
<path d="M8205 2937 c-3 -7 -4 -78 -3 -157 l3 -145 103 -3 c96 -3 102 -2 102
17 0 18 -8 20 -77 23 l-78 3 -3 48 -3 47 60 0 c68 0 91 6 91 26 0 15 -8 17
-58 14 -18 -1 -46 1 -63 5 -28 6 -30 9 -27 48 l3 42 78 3 c68 2 78 5 75 20 -3
14 -18 17 -101 20 -74 2 -99 0 -102 -11z"/>
<path d="M8510 2791 c0 -154 1 -161 20 -161 18 0 20 7 20 54 0 67 7 86 30 86
12 0 32 -23 57 -67 27 -47 46 -69 61 -71 31 -5 28 21 -8 75 -29 43 -38 73 -22
73 24 0 52 43 52 79 0 62 -34 85 -131 90 l-79 3 0 -161z m141 109 c26 -15 26
-66 -1 -80 -12 -6 -38 -10 -58 -8 -30 2 -38 7 -40 27 -2 12 -1 34 2 47 5 20
13 24 42 24 19 0 44 -5 55 -10z"/>
<path d="M8788 2945 c-3 -3 21 -74 52 -158 47 -123 62 -153 79 -155 14 -2 24
4 31 20 27 64 110 283 110 291 0 4 -9 7 -21 5 -16 -2 -30 -28 -66 -121 -26
-65 -50 -114 -54 -110 -4 4 -23 51 -42 103 -20 52 -39 103 -42 113 -7 16 -35
23 -47 12z"/>
<path d="M9140 2790 c0 -153 1 -160 20 -160 19 0 20 7 20 160 0 153 -1 160
-20 160 -19 0 -20 -7 -20 -160z"/>
<path d="M9630 2790 l0 -160 105 0 c98 0 105 1 105 20 0 18 -7 20 -80 20 l-80
0 0 50 0 49 68 3 c59 3 67 5 67 23 0 18 -7 20 -63 21 -34 0 -67 5 -73 11 -6 6
-8 25 -4 47 l7 36 74 0 c67 0 74 2 74 20 0 19 -7 20 -100 20 l-100 0 0 -160z"/>
<path d="M5415 2381 c-11 -5 -42 -33 -69 -62 -28 -30 -107 -114 -178 -186
l-127 -133 144 0 c81 0 145 4 147 9 2 6 64 72 137 148 74 76 155 159 180 186
l45 47 -129 -1 c-72 0 -139 -4 -150 -8z"/>
<path d="M5738 2233 c-84 -86 -170 -174 -191 -195 l-39 -38 145 0 144 0 114
122 c63 67 144 153 182 191 37 38 67 71 67 73 0 2 -60 4 -134 4 l-134 0 -154
-157z"/>
<path d="M4927 2362 c-20 -22 -21 -29 -4 -35 6 -2 0 -2 -15 0 -21 3 -28 0 -28
-11 0 -9 -4 -16 -10 -16 -5 0 -10 -12 -10 -26 0 -21 -4 -25 -17 -20 -10 4 -14
3 -9 -1 4 -4 15 -8 24 -9 50 -3 52 -4 52 -34 0 -17 5 -30 13 -31 6 0 2 -5 -10
-11 -13 -6 -23 -18 -23 -27 1 -14 2 -14 14 2 17 22 26 22 26 -3 0 -20 -32 -44
-44 -33 -3 3 -6 1 -6 -5 0 -25 49 -13 64 16 8 15 15 23 16 18 0 -5 6 -3 14 4
8 6 12 18 9 26 -3 8 1 14 8 14 14 0 139 114 140 127 0 5 18 23 41 41 l40 32
-134 0 c-118 0 -137 -2 -151 -18z m103 4 c0 -2 -18 -6 -39 -8 -22 -2 -37 0
-35 4 5 8 74 11 74 4z m73 -3 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35
-2 23 -4z m-136 -145 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m25 -20 c-7 -7 -12 -8 -12 -2 0 14 12 26 19 19 2 -3 -1 -11 -7 -17z"/>
<path d="M1784 2232 c-100 -19 111 -22 1303 -22 1175 0 1342 2 1353 15 11 13
-141 14 -1312 12 -728 -1 -1333 -4 -1344 -5z"/>
<path d="M6338 2223 c-8 -10 263 -13 1351 -13 1082 0 1361 3 1361 13 0 9 -277
12 -1351 12 -1068 0 -1353 -3 -1361 -12z"/>
<path d="M4850 2029 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M0 20 c0 -20 7 -20 5400 -20 5393 0 5400 0 5400 20 0 20 -7 20 -5400
20 -5393 0 -5400 0 -5400 -20z"/>
</g>
</svg>




    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
